<mat-card >
    <mat-card-title class="font-weight-bold caption-color">Ageing</mat-card-title>
    <mat-divider></mat-divider>
    <!-- <mat-card-subtitle class="pt-2 text-uppercase font-weight-bold">
        {{ageing.cusname}} <span class="text-dark"> [ {{ageing.cuscode}} ]</span> 
    </mat-card-subtitle> -->

    <mat-card-content class="pt-2 text-uppercase">

        <div class="row alert alert-info ml-2 mr-2">
            <div class="col-sm-6">
                <div class="row">
                <div class="col-sm-8 pl-2">
                    Sale Collection Days 
                </div>
                <div class="col-sm-2">:</div>
                <div class="col-sm-2 font-weight-bold">
                    {{ageing?.saleCollectionDays}}   
                </div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="row">
                    <div class="col-sm-8">
                        Sale Overdue Count       
                    </div>
                    <div class="col-sm-2">:</div>
                    <div class="col-sm-2 pr-2 font-weight-bold">
                        {{ageing?.saleOverDueDays}}     
                    </div>
                    </div>
            </div>

            <div class="col-sm-6">
                <div class="row">
                    <div class="col-sm-8 pl-2">
                        Service Collection Days        
                    </div>
                    <div class="col-sm-2">:</div>
                    <div class="col-sm-2 font-weight-bold">
                        {{ageing?.serviceCollectionDays}}
                    </div>
                    </div>
                
            </div>
            <div class="col-sm-6">
                <div class="row">
                    <div class="col-sm-8">
                        Service Overdue Count        
                    </div>
                    <div class="col-sm-2">:</div>
                    <div class="col-sm-2 pr-2 font-weight-bold">
                        {{ageing?.serviceOverDueDays}}
                    </div>
                    </div>
                
            </div>

        </div>


        <mat-table #table [dataSource]="dataSource" matSort matSortStart="desc" *ngIf="dataSource.data.length>0">
            <ng-container matColumnDef="days30">
                <mat-header-cell mat-sort-header *matHeaderCellDef> 0-30 </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.days30}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="days60">
                <mat-header-cell mat-sort-header *matHeaderCellDef> 31-60 </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.days60}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="days90">
                <mat-header-cell mat-sort-header *matHeaderCellDef> 61-90 </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.days90}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="days120">
                <mat-header-cell mat-sort-header *matHeaderCellDef> 91-120 </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.days120}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="more120days">
                <mat-header-cell mat-sort-header *matHeaderCellDef> Above 120 </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.more120days}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="CrAmt">
                <mat-header-cell mat-sort-header *matHeaderCellDef> Credit </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.CrAmt}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="TotalAmt">
                <mat-header-cell mat-sort-header *matHeaderCellDef> Balance </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.TotalAmt}} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="ageingHeader"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ageingHeader;"></mat-row>

        </mat-table>
    </mat-card-content>
</mat-card>